import { DimensionalGoldButton } from "../components/v2/ActionRow";
import PageTransition from "../components/v2/PageTransition";
import Wordmark from "../components/v2/Wordmark";
import "../components/v2/v2-question-surface.css";

export default function SurfaceStill({
  headline,
  body,
  primaryLabel,
  secondaryLabel,
  className = "",
  direction = "forward",
  onPrimary,
  onSecondary,
}) {
  return (
    <section className={`tgc-v2-surface tgc-v2-surface--still ${className}`.trim()} aria-labelledby="still-heading">
      <PageTransition direction={direction}>
        <div className="tgc-v2-still-shell">
          <Wordmark variant="stacked" />
          <div className="tgc-v2-still-copy">
            <h1 className="tgc-v2-still-heading" id="still-heading">{headline}</h1>
            <p className="tgc-v2-still-body">{body}</p>
          </div>
          <div className="tgc-v2-still-actions">
            <DimensionalGoldButton className="tgc-v2-button tgc-v2-button--gold tgc-v2-still-primary" onClick={onPrimary}>
              {primaryLabel}
            </DimensionalGoldButton>
            {secondaryLabel && (
              <button className="tgc-v2-still-link" type="button" onClick={onSecondary}>
                {secondaryLabel}
              </button>
            )}
          </div>
        </div>
      </PageTransition>
    </section>
  );
}
